import { createSelector, createStructuredSelector } from "reselect"
import { createFormValueSelector } from "../../../FormReducer/reducer"
import { createGetState } from "../../../Redux/selector"

export const URL = '/api/findrisc/insert'

export const mapStateToProps = () => {

    const value = createSelector(
        (_, { fetchedData }) => fetchedData,
        (_, { storeTarget }) => storeTarget,
        (_, { name }) => name,
        (fetchedData, storeTarget, name) =>
            fetchedData && storeTarget && name &&
            createFormValueSelector(storeTarget, fetchedData, name)
    )

    const mapLocalStateToProps = createStructuredSelector({
        value
    })

    return createSelector(
        createGetState(),
        (_, props) => props,
        mapLocalStateToProps
    )

}